import { createSelector } from "@reduxjs/toolkit"
import type { UseQueryResult } from "@tanstack/react-query"

export const selectQueryStatus = createSelector(
  [(results: UseQueryResult[]) => results],
  (results) => {
    let isLoading = false
    let isError = false
    let isSuccess = true
    let isPending = false
    let isFetching = false
    const errors: Error[] = []

    for (const result of results) {
      if (!result.data) {
        isLoading ||= result.isLoading
        isError ||= result.isError
        isPending ||= result.isPending
        isFetching ||= result.isFetching
        if (result.error) errors.push(result.error)
        isSuccess = false
      }
    }

    return {
      isLoading,
      isError,
      isSuccess:
        isSuccess ||
        (!isPending && !isLoading && !isError && errors.length === 0),
      errors,
      isPending,
      isFetching,
    }
  },
)
